import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import api from "../services/api";

const AdicionarCondicionanteModal = ({
  open,
  onClose,
  processoSelecionado,
  tipo = "solicitacao",
  onCondicionanteAdicionado,
}) => {
  const [nomeCondicionante, setNomeCondicionante] = useState("");
  const [instrucoes, setInstrucoes] = useState("");
  const [prazo, setPrazo] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleAdicionarCondicionante = async () => {
    try {
      setError("");
      setSuccess("");

      if (!nomeCondicionante.trim()) {
        setError("Por favor, preencha o nome do condicionante.");
        return;
      }

      if (!instrucoes.trim()) {
        setError("Por favor, preencha as instruções para o solicitante.");
        return;
      }

      setLoading(true);

      const dataEnvio =
        tipo === "protocolo"
          ? {
              protocoloId: processoSelecionado.id,
              fileName: nomeCondicionante,
              instrucoes: instrucoes,
              prazoParaResposta: prazo ? prazo : null,
            }
          : {
              solicitacaoDeLicencaId: processoSelecionado.id,
              fileName: nomeCondicionante,
              instrucoes: instrucoes,
              prazoParaResposta: prazo ? prazo : null,
            };

      await api.post("Condicionante/", dataEnvio);

      setSuccess("Condicionante adicionado com sucesso!");
      if (onCondicionanteAdicionado) {
        onCondicionanteAdicionado();
      }
      setTimeout(() => {
        setNomeCondicionante("");
        setInstrucoes("");
        setPrazo("");
        onClose();
      }, 3000);
    } catch (error) {
      setError(
        error.response?.data?.message ||
          "Erro ao adicionar condicionante. Tente novamente."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleFechar = () => {
    if (!loading) {
      setNomeCondicionante("");
      setInstrucoes("");
      setPrazo("");
      setError("");
      setSuccess("");
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={handleFechar} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ pb: 1 }}>
        Adicionar Documento Condicionante
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ pt: 3 }}>
        <Alert severity="info" sx={{ mb: 3 }}>
          <Typography variant="body2" component="div">
            <strong>O que são condicionantes?</strong>
            <br />
            Os documentos condicionantes exigem uma resposta do solicitante.
            Eles permitem que você solicite documentos específicos ou ações que
            devem ser realizadas pelo solicitante como condição para a
            continuidade do processo.
          </Typography>
        </Alert>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        {success && (
          <Alert severity="success" sx={{ mb: 2 }}>
            {success}
          </Alert>
        )}

        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <TextField
            fullWidth
            label="Nome do Documento Condicionante"
            placeholder="Ex: Licença de funcionamento da prefeitura"
            value={nomeCondicionante}
            onChange={(e) => setNomeCondicionante(e.target.value)}
            disabled={loading}
            multiline
            rows={2}
            required
            inputProps={{ maxLength: 255 }}
          />

          <TextField
            fullWidth
            label="Instruções para o Solicitante"
            placeholder="Ex: Envie a cópia da licença de funcionamento emitida pela prefeitura municipal..."
            value={instrucoes}
            onChange={(e) => setInstrucoes(e.target.value)}
            disabled={loading}
            multiline
            rows={4}
            helperText="Descreva detalhadamente o que o solicitante deve fazer"
            required
            inputProps={{ maxLength: 500 }}
          />

          <TextField
            fullWidth
            label="Prazo para a Resposta (Opcional)"
            type="date"
            value={prazo}
            onChange={(e) => setPrazo(e.target.value)}
            disabled={loading}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
      </DialogContent>

      <DialogActions sx={{ mt: 3, justifyContent: "flex-end", gap: 1 }}>
        <Button onClick={handleFechar} disabled={loading}>
          Cancelar
        </Button>
        <Button
          onClick={handleAdicionarCondicionante}
          variant="contained"
          color="secondary"
          disabled={loading}
        >
          {loading ? "Adicionando..." : "Adicionar Condicionante"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AdicionarCondicionanteModal;
